import { LIBERTY_BLOG_POSTS } from "./libertyBlogPosts";

export function LibertyBlogSection() {
  if (!LIBERTY_BLOG_POSTS.length) {
    return null;
  }

  return (
    <section className="public-range-section public-liberty-blog" id="updates">
      <div className="public-range-section__heading">
        <p className="public-range-eyebrow">Range notes</p>
        <h2>Latest from Liberty Long Range</h2>
      </div>
      <div className="public-liberty-blog__grid">
        {LIBERTY_BLOG_POSTS.map((post) => (
          <article className="public-liberty-blog__card" key={post.slug}>
            <p>{post.publishedAt}</p>
            <h3>{post.title}</h3>
            <p>{post.excerpt}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
